import React from 'react';
import styled from 'styled-components';

interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: 'small' | 'regular' | 'large' | 'medium';
}

const StyledSpinner = styled.svg<{
  offset: number;
  duration: number;
}>`
  animation: rotator ${({ duration }) => duration}s linear infinite;

  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .path {
    stroke-dasharray: ${({ offset }) => offset};
    transform-origin: center;
    stroke: currentColor;
    stroke-dashoffset: ${({ offset }) => offset / 4};
  }
`;

export const StyledSpinnerView = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const SpinnerComponent = ({ size, style }: SpinnerProps) => {
  const [width, height] = (() => {
    if (size === 'small') {
      return [14, 14];
    }
    if (size === 'medium') {
      return [32, 32];
    }
    if (size === 'large') {
      return [44, 44];
    }

    return [24, 24];
  })();

  return (
    <StyledSpinnerView style={style}>
      <StyledSpinner
        offset={63}
        duration={0.6}
        width={width}
        height={height}
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="path"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          cx="13"
          cy="13"
          r="10"
        />
      </StyledSpinner>
    </StyledSpinnerView>
  );
};

export default SpinnerComponent;
